module.exports = __webpack_public_path__ + "static/flooralphamap-932e9e81929663befd1613e94381982e.png";